/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { tp } from 'app/utils/typograf';

import { Desktop, Mobile } from 'app/components/Responsive';

import styles from './dish-title.scss';


export function DishTitle(props) {
    const {
        joinDishTitlesinMobile,
        strongTitle = '',
        title,
        colors = 'default',
        layout = 'default',
        pageId,
    } = props;

    const titleClasses = cn({
        // eslint-disable-next-line dot-notation
        [styles['dish__title']]: true,
        [styles['dish__title--dark']]: colors === 'dark',
        [styles['dish__title--blue']]: colors === 'blue',
        [styles['dish__title--pink']]: colors === 'pink',
        [styles[`dish__title--${layout}`]]: true,
        'title-lp': true,
        [pageId]: true,
    });

    return (
        <>
            {strongTitle && (
                <p className={titleClasses}>
                    <strong>
                        {tp.execute(strongTitle)}
                    </strong>
                </p>
            )}
            <Mobile>
                {joinDishTitlesinMobile ? (
                    <p className={titleClasses}>
                        {tp.execute(title.join(' '))}
                    </p>
                ) : (
                    title.map((str) => (
                        <p className={titleClasses} key={str}>{tp.execute(str)}</p>
                    ))
                )}
            </Mobile>
            <Desktop>
                {title.map((str) => (
                    <p className={titleClasses} key={str}>{tp.execute(str)}</p>
                ))}
            </Desktop>
        </>
    );
}

DishTitle.propTypes = {
    joinDishTitlesinMobile: PropTypes.bool.isRequired,
    strongTitle: PropTypes.string,
    title: PropTypes.arrayOf(PropTypes.string).isRequired,
    colors: PropTypes.oneOf(['default', 'dark', 'blue', 'pink']),
    layout: PropTypes.oneOf(['default', 'secondary', 'upsell']),
};

